import { Flex } from "@chakra-ui/react"
import { tabs } from "../../../../common/constants/search-constants"
import { Tab } from "../../../../common/types/global"
import { FhResponseData } from "../../../../common/types/search"
import NavigationTabWrapper from "../../../shared/NavigationTabWrapper"
import SearchTab from "./SearchTab/SearchTab"

type Props = {
  typeSelector: FhResponseData
  selectedTab: Tab
  handleSetSelectedTab: (tab: Tab, urlParams: string) => void
}

const SearchTabs = ({ typeSelector, selectedTab, handleSetSelectedTab }: Props) => {
  return (
    <Flex
      id="tabs-wrapper"
      as="section"
      gap="8"
      borderBottom="1px solid"
      borderBottomColor="gray.300"
      mt={{ base: "6", sm: "8", md: "10" }}
    >
      {Object.keys(tabs).map((tab: Tab) => {
        const currentTab = typeSelector?.filtersection?.find((f) => f.value.value === tab)
        const count = currentTab?.nr ?? 0
        const isSelected = tab === selectedTab

        return (
          <NavigationTabWrapper isSelected={isSelected} isDisabled={!count} key={tab}>
            <SearchTab
              name={tab}
              count={count}
              isSelected={isSelected}
              handleSetSelectedTab={handleSetSelectedTab}
              urlParams={currentTab?.link?.url_params}
            />
          </NavigationTabWrapper>
        )
      })}
    </Flex>
  )
}

export default SearchTabs
